import styled from 'styled-components';

export const AuthenticationContainer = styled.div`
  margin: 2rem auto;
  display: flex;
  justify-content: center;
`;
